import store from "./App/Store";

import VueRouter from 'vue-router';
import pipeline from './App/Middlewares/_pipeline';

const routes = [
    ...require('./App/Routes/routesAuth').routes,
    ...require('./App/Routes/routesProfile').routes,
    ...require('./App/Routes/routesDashboard').routes,
    ...require('./App/Routes/routesClients').routes,
    ...require('./App/Routes/routesDocuments').routes,
    ...require('./App/Routes/routesApp').routes,
    ...require('./App/Routes/routesSuper').routes,
];

const router = new VueRouter({
    history: true,
    mode: 'history',
    routes,
    linkActiveClass: 'is-active'
});

router.beforeEach((to, from, next) => {
    // https://www.digitalocean.com/community/tutorials/vuejs-vue-router-modify-head
    const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

    if (nearestWithTitle) {
        document.title = process.env.MIX_APP_NAME + ' :: ' + nearestWithTitle.meta.title;
    } else {
        document.title = process.env.MIX_APP_NAME;
    }

    if (!to.meta.middleware) {
        return next();
    }

    const middleware = to.meta.middleware;

    const context = {
        to,
        from,
        next,
        store
    };

    return middleware[0]({
        ...context,
        next: pipeline(context, middleware, 1)
    });
});

export default router;
